export const findActiveQuizSlug = (quizzes: any[]): string | null => {
  const now = Date.now();

  const active = quizzes.filter(q => {
    const started = !q.startsDate || Number(q.startsDate) <= now;
    const ended = !!q.endsDate && Number(q.endsDate) <= now;
    return started && !ended;
  });

  if (!active.length) return null;

  const latest = active.reduce((acc: any, cur: any) => {
    return Number(cur.startsDate || 0) > Number(acc.startsDate || 0) ? cur : acc;
  });

  return latest?.quizNameSlug ?? null;
};
